import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataGeneralLedger } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_GENERAL_LEDGER = defineMasterdataEntity<MasterdataGeneralLedger>({
  name: 'general-ledger',
  responseKey: 'generalLedgers',
  displayWith: (g) => keyName(g.key, g.name),
  secondaryWith: (g) => g.accountText1,
  icon: 'fa-regular fa-book-open',
  title: 'Sachkontosuche',
  label: 'Sachkonto',
  placeholder: 'Sachkonto suchen...',
  columns: [
    {
      label: 'Sachkonto',
      type: 'entity',
      icon: 'fa-regular fa-book-open',
      value: (e) => keyName(e.key, e.name),
      secondary: (e) => e.accountText1,
    },
    { label: 'Kontotext 1', type: 'text', value: (e) => e.accountText1 },
    { label: 'Kontotext 2', type: 'text', value: (e) => e.accountText2 },
    { label: 'Steuerschlüssel', type: 'text', value: (e) => e.taxCode },
    { label: 'Gesperrt am', type: 'text', value: (e) => e.lockedDate },
    { label: 'Gelöscht am', type: 'text', value: (e) => e.deletionDate },
    { label: 'UID-Nummer', type: 'text', value: (e) => e.vatId },
    { label: 'Budgetposition', type: 'text', value: (e) => e.budgetPosition },
    { label: 'Gemeinkostensatz', type: 'text', value: (e) => e.overheadRate },
    { label: 'Infotext', type: 'text', value: (e) => e.infoText },
    { label: 'Kontoart', type: 'text', value: (e) => e.accountType },
    { label: 'Steuerbuchungsart', type: 'text', value: (e) => e.taxPostingType },
    { label: 'Aufwand/Ertrag', type: 'text', value: (e) => e.expenseRevenueType },
    { label: 'Brutto/Netto', type: 'text', value: (e) => e.grossNet },
    {
      label: 'Zusammenfassende Meldung',
      type: 'text',
      value: (e) => e.recapitulativeStatement,
    },
    { label: 'Soll/Haben', type: 'text', value: (e) => e.debitCredit },
    { label: 'Planungsart', type: 'text', value: (e) => e.planningType },
    { label: 'Kostenkategorie', type: 'text', value: (e) => e.costCategory },
    { label: 'Buchungsart', type: 'text', value: (e) => e.postingKind },
    {
      label: 'Kostenrechnungsrelevant',
      type: 'text',
      value: (e) => (e.costAccountingRelevant ? 'Ja' : 'Nein'),
    },
    {
      label: 'Kostenrechnungsvorschlag',
      type: 'text',
      value: (e) => (e.costAccountingProposal ? 'Ja' : 'Nein'),
    },
    {
      label: 'Kostenträger erforderlich',
      type: 'text',
      value: (e) => (e.costObjectRequired ? 'Ja' : 'Nein'),
    },
    {
      label: 'Manuelle Buchung erlaubt',
      type: 'text',
      value: (e) => (e.manualPostingAllowed ? 'Ja' : 'Nein'),
    },
    {
      label: 'Budgetbuchhaltung',
      type: 'text',
      value: (e) => (e.budgetAccounting ? 'Ja' : 'Nein'),
    },
    {
      label: 'Steuervorschlag',
      type: 'text',
      value: (e) => (e.taxProposal ? 'Ja' : 'Nein'),
    },
    {
      label: 'Kontovorschlag',
      type: 'text',
      value: (e) => (e.accountProposal ? 'Ja' : 'Nein'),
    },
    {
      label: 'Valutabuchung',
      type: 'text',
      value: (e) => (e.valueDatePosting ? 'Ja' : 'Nein'),
    },
    {
      label: 'Einkaufsrelevant',
      type: 'text',
      value: (e) => (e.purchasingRelevant ? 'Ja' : 'Nein'),
    },
    {
      label: 'Fremdleistung',
      type: 'text',
      value: (e) => (e.externalService ? 'Ja' : 'Nein'),
    },
  ],
});
